let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aEIRL")).then(() => parcelRequire('5DcAn'));